<template>
  <div class="topic-type table-topic">
    <div class="topic-container">
      <topic-info :info="info" />
      <div class="operation">
        <div class="tag-list">
          <div v-for="(config, type) in tagConfigs" :key="type" class="tag-item" v-if="info[config.listKey] && info[config.listKey].length > 0">
            <p>{{ config.label }}<span v-if="info[config.electKey] === 0">(选填)</span></p>
            <ul>
              <li v-for="(item, index) in info[config.listKey]" :key="index" :class="{ active: selectedIndexes[type] === index }" @click="handleSelect(type, item, index)">
                {{ item.option_name }}
              </li>
            </ul>
          </div>
        </div>
        <!-- 自定义输入 -->
        <div class="input-container">
          <van-field v-model.trim="customInput" maxlength="8" placeholder="请输入标签没有的项目" />
          <van-button @click="addCustomProject">添加</van-button>
        </div>
      </div>
    </div>
    <!-- 指令 -->
    <div class="instruction-container" v-if="info.edict">
      <div class="content" :class="{open: instructionShow}">
        <p v-show="instructionShow">{{ info.edict }}</p>
        <van-icon name="arrow-left" v-show="instructionShow" @click="instructionShow = false" />
      </div>
      <div class="btn" @click="instructionShow = true">
        <img src="@/assets/img/instruction.png" alt="">
      </div>
    </div>
    <!-- 表格弹框 -->
    <div class="project-container" v-if="projectVisible">
      <div class="project-shadow" @click="projectHide"></div>
      <div class="project-table">
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column width="80" label="序号" align="center" type="index"></el-table-column>

          <template v-for="(config, type) in tagConfigs">
            <el-table-column :key="type" :prop="config.nameKey" :label="config.label" align="center" show-overflow-tooltip :formatter="stateFormat" v-if="info[config.listKey] && info[config.listKey].length >= 1">
              <template slot="header">
                {{ config.label }}<span v-if="info[config.electKey] === 0">(选填)</span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row[config.nameKey] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="时间" align="center" width="160">
            <template slot-scope="scope">{{ moment(Number(scope.row.ctime * 1000)).format("MM/DD HH:mm") }}</template>
          </el-table-column>
          <el-table-column align="center" width="60">
            <template slot-scope="scope">
              <i class="el-icon-close" @click="deleteRecord(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <tip-modal v-if="tipShow" :show.sync="tipShow" :options="tipOptions" @confirm="tipConfirm" @cancel="tipCancel"></tip-modal>
  </div>
</template>

<script>
import TopicInfo from "../TopicInfo";
import { getuid, getreviewid } from "/src/api/userdata.js";
import { chooseproject, programadd, delchoose } from "@/api";
import moment from "moment";
import "@/plugin/element";
import TipModal from "../TipModal";
export default {
  name: "TableTopic",
  components: {
    TopicInfo,
    TipModal,
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    topicInfo: {
      type: Object,
      required: true
    },
    projectVisible: {
      type: Boolean,
      default: false
    },
    isHand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {},
      tableTotal: 0,
      tableData: [],
      // 选中的标签索引
      selectedIndexes: {
        assist: -1,
        envir: -1,
        place: -1,
        noun: -1,
        item: -1
      },
      // 选中的标签数据
      selectedData: {},
      // 自定义输入
      customInput: '',
      // 计分相关
      score: 0,
      // 计分类型映射
      scoreTypeMap: {
        1: 'item_id',
        2: 'envir_id',
        3: 'assist_id',
        4: 'place_id',
        5: 'noun_id'
      },
      // 标签配置
      tagConfigs: {
        assist: {
          label: '辅助',
          listKey: 'assist_list',
          electKey: 'elect_assist',
          nameKey: 'assist_name',
          idKey: 'assist_id',
          type: 3
        },
        envir: {
          label: '环境',
          listKey: 'envir_list',
          electKey: 'elect_envir',
          nameKey: 'envir_name',
          idKey: 'envir_id',
          type: 2
        },
        place: {
          label: '场所',
          listKey: 'place_list',
          electKey: 'elect_place',
          nameKey: 'place_name',
          idKey: 'place_id',
          type: 4
        },
        noun: {
          label: '词性',
          listKey: 'noun_list',
          electKey: 'elect_noun',
          nameKey: 'noun_name',
          idKey: 'noun_id',
          type: 5
        },
        item: {
          label: '项目',
          listKey: 'item_list',
          electKey: 'elect_item',
          nameKey: 'item_name',
          idKey: 'item_id',
          type: 1
        }
      },
      tipShow: false,
      tipOptions: {},
      instructionShow: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.score = val;
      },
      immediate: true
    },
    projectVisible: {
      handler(val) {
        if (val && this.tableData.length <= 0) {
          this.$emit('update:projectVisible', false);
          return this.$vantnotify({ type: 'warning', message: '请选择（标签类型名称）+标签' });
        }
      }
    },
    tableTotal: {
      handler(val) {
        this.$emit('table-total-change', val);
      },
      immediate: true
    }
  },
  created() {
    this.info = this.$route.query.topic_sort * 1 > 0 ? this.topicInfo.topic_info : this.topicInfo;
    this.getTableData();
  },
  methods: {
    moment,
    // 统一的标签选择处理方法
    handleSelect(type, item, index) {
      const config = this.tagConfigs[type];

      // 设置选中索引
      this.$set(this.selectedIndexes, type, index);

      // 设置选中数据
      this.selectedData[config.nameKey] = item.option_name;
      this.selectedData[config.idKey] = item.option_id;
      // 如果是项目标签，需要验证必选项并提交
      if (type === 'item') {
        if (!this.validateRequired()) {
          // 重置选中的项目标签
          this.selectedIndexes.item = -1;
          this.selectedData[config.nameKey] = '';
          this.selectedData[config.idKey] = '';
          return;
        }
        this.submitSelection();
      }
    },

    // 验证必选标签
    validateRequired(excludeType) {
      for (const [type, config] of Object.entries(this.tagConfigs)) {
        // 跳过指定类型验证
        if (type === excludeType) continue;
        const isRequired = this.info[config.electKey] * 1 === 1;
        if (isRequired && !this.selectedData[config.idKey]) {
          this.$vantnotify({
            type: 'warning',
            message: `请选择${config.label}标签`
          });
          return false;
        }
      }
      return true;
    },

    // 提交选择
    async submitSelection(is_attach) {
      const uid = getuid();
      const review_id = getreviewid();

      let obj = {
        ...this.selectedData,
        uid,
        review_id,
        topic_id: this.info.id,
        is_attach: is_attach || 0
      };
      let data = is_attach ? { ...obj, item_name: this.customInput } : obj;

      try {
        const res = await chooseproject(data);
        if (res.code * 1 !== 1) {
          return this.$vantnotify(res.msg);
        }
        this.resetSelection();
        if (this.isHand) {
          this.$emit('update:isHand', false);
        }
        await this.getTableData();
      } catch (e) {
        console.error(e);
      }
    },

    // 添加自定义项目
    async addCustomProject() {
      if (!this.validateRequired('item')) return;
      if (!this.customInput) {
        return this.$vantnotify('添加项目名称不能为空');
      };

      const uid = getuid();

      try {
        // 先添加自定义项目
        const res = await programadd({
          uid,
          topic_id: this.info.id,
          name: this.customInput
        });

        if (res.code * 1 !== 1) {
          return this.$vantnotify(res.msg);
        }
        await this.submitSelection(1);
        this.customInput = '';
      } catch (e) {
        console.error(e);
      }
    },

    // 计算分数
    calculateScore() {
      if (this.isHand) return;
      if (this.tableData.length === 0) {
        this.score = '';
      } else {
        const { full_mark, half_mark } = this.info;

        // 1分标准匹配数
        const fullMatches = this.checkMatchCount(full_mark.label, this.tableData, full_mark.type);

        // 0.5分标准匹配数
        const halfMatches = this.checkMatchCount(half_mark.label, this.tableData, half_mark.type);

        if (fullMatches >= full_mark.total_num * 1) {
          this.score = 1;
        } else if (halfMatches >= half_mark.total_num * 1) {
          this.score = 0.5;
        } else {
          this.score = 0;
        }
      }
      this.$emit('input', this.score);
    },

    // 检查标签匹配数量
    checkMatchCount(standards, records, type) {
      const configKey = Object.keys(this.tagConfigs).find(key => {
        return this.tagConfigs[key].type === type * 1;
      });
      const key = configKey ? this.tagConfigs[configKey].idKey : '';

      let num = standards.reduce((matches, standard) => {
        return matches + records.filter(record => standard.id * 1 === record[key] * 1).length;
      }, 0);

      return num;
    },

    // 重置选择
    resetSelection() {
      // 重置所有选中索引
      Object.keys(this.selectedIndexes).forEach(key => {
        this.$set(this.selectedIndexes, key, -1);
      });
      // 清空选中数据
      this.selectedData = {};
    },
    projectHide() {
      this.$emit('toggle-project');
    },
    async getTableData() {
      const uid = getuid();
      const review_id = getreviewid();
      let params = {
        uid,
        review_id,
        topic_id: this.info.id,
      }
      const res = await this.$http.get('must-toprecgrid/list', { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.tableTotal = res.data.total || 0;
      this.tableData = res.data.list || [];
      this.calculateScore()
    },
    // 格式化表格消息内容
    stateFormat(row, column, cellValue) {
      if (!cellValue) return "";
      if (cellValue.length > 4) {
        //最长固定显示4个字符
        return cellValue.slice(0, 4) + "...";
      }
      return cellValue;
    },
    // 删除项目记录
    async deleteRecord(row) {
      this.tipOptions = {
        type: 1,
        data: row,
        message: "删除项目记录后会影响本题得分，确定删除吗？"
      };
      this.tipShow = true;
    },
    async tipConfirm() {
      if (this.tipOptions.type === 1) {
        // 删除项目记录
        const res = await delchoose({ id: this.tipOptions.data.id });
        if (res.code * 1 !== 1) {
          return this.$vantnotify(res.msg);
        }
        await this.getTableData();
      }
      this.tipShow = false;
    },
    tipCancel() {
      this.tipShow = false;
    }
  },
}
</script>

<style lang="less" scoped>
.operation {
  // height: 3rem;
  flex: 1;
  padding: 0.2rem 0.15rem;
  overflow-y: scroll;
  .tag-list {
    .tag-item {
      display: flex;
      line-height: 0.28rem;
      margin-bottom: 0.03rem;
      &:last-child {
        margin-bottom: 0;
      }
      p {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.14rem;
        font-weight: bold;
        color: #630200;
        line-height: 1.2;
        padding-top: 0.08rem;
        span {
          font-size: 0.1rem;
          color: #fe6765;
        }
      }
      ul {
        flex: 1;
        li {
          display: inline-block;
          height: 0.28rem;
          font-size: 0.12rem;
          color: #630200;
          padding: 0 0.1rem;
          background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
          box-shadow: inset 0 0 0.06rem 1px #ffaa71;
          border-radius: 0.08rem;
          cursor: pointer;
          margin: 0 0 0.1rem 0.1rem;
          &.active {
            color: #5a3600;
            background: #ffe56f;
            box-shadow: inset 0 0.03rem 0.06rem 1px #ffcd00;
          }
        }
      }
    }
  }
  .input-container {
    height: 0.3rem;
    margin: 0.1rem 0 0 0.4rem;
    background: #ffffff;
    overflow: hidden;
    display: flex;
    align-items: center;
    width: fit-content;
    .van-cell {
      width: 2.3rem;
      height: 100%;
      padding: 0 0.1rem;
      font-size: 0.12rem;
      border-radius: 0.04rem 0 0 0.04rem;
      line-height: 0.28rem;
      border: 1px solid #ff7e2b;
      &::after {
        display: none;
      }
    }
    .van-button {
      height: 100%;
      border: none;
      border-radius: 0 0.04rem 0.04rem 0;
      background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
      font-size: 0.12rem;
      color: #fff;
    }
  }
}
.project-shadow {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: black;
  opacity: 0.5;
  z-index: 101;
  position: fixed;
  top: 0;
  left: 0;
}
.project-table {
  width: 100%;
  background: #fff7ee;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0.16rem 0.16rem 0 0;
  z-index: 102;
  overflow: hidden;
  padding: 0.16rem 0.16rem 0.9rem;
  box-sizing: border-box;
  ::v-deep .el-table {
    border: 1px solid #ffcd94;
    border-radius: 0.1rem;
    .el-table__cell {
      padding: 0.08rem 0;
    }
  }
  ::v-deep thead tr {
    background: linear-gradient(302deg, #fff6e5 0%, #ffebd4 100%);
    th.el-table__cell {
      background: none;
      border: none;
      font-size: 0.13rem;
      font-weight: bold;
      color: #630200;
      span {
        font-size: 0.1rem;
        font-weight: normal;
        color: #fe6765;
        margin-left: 0.02rem;
      }
    }
  }
  ::v-deep .el-table__body-wrapper {
    max-height: 50vh;
    overflow-y: scroll;
  }
  ::v-deep tbody {
    tr {
      border-bottom: 1px solid #ebebeb;
      &:last-child {
        border-bottom: none;
      }
    }
    td {
      border-right: none;
      font-size: 0.12rem;
      color: #5a3600;
    }
    .el-icon-close {
      font-size: 0.14rem;
      font-weight: bold;
      color: #fe6765;
    }
  }
}
.instruction-container {
  min-width: 0.46rem;
  height: 0.46rem;
  position: fixed;
  bottom: 1rem;
  left: 0;
  border-radius: 0.23rem;
  .content {
    width: 0;
    height: 0.43rem;
    background: linear-gradient(205deg, #ffecd6 0%, #ffda95 100%);
    border-radius: 0 0.2rem 0.2rem 0;
    border: 1px solid #ffc767;
    font-size: 0.12rem;
    color: #540200;
    line-height: 0.14rem;
    position: absolute;
    left: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    transition: all 0.1s ease;
    box-sizing: border-box;
    p {
      // 限制最多显示两行
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
    }
    .van-icon {
      color: #f59f0c;
      font-size: 0.14rem;
      margin-left: 0.05rem;
    }
    &.open {
      width: max-content;
      max-width: 3rem;
      padding: 0 0.15rem 0 0.3rem;
    }
  }
  .btn {
    width: 0.46rem;
    height: 0.46rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>